import React, { FC, useCallback } from "react";
import { useIsMobile } from "src/hooks/viewport/useViewportCategory";
import {
  ASCENDING,
  DESCENDING,
  OrderItem,
  OrderValue,
} from "../../../../globalTypes";
import DesktopOrderButtons from "./DesktopOrderButtons";
import MobileOrderButtons from "./MobileOrderButtons";

export type OrderButtonsProps = {
  columnKey: string;
  orderItem?: OrderItem;
  onOrder: (columnKey: string, order: OrderValue) => void;
};

const OrderButtons: FC<OrderButtonsProps> = ({
  columnKey,
  orderItem,
  onOrder,
}) => {
  const isMobile = useIsMobile();

  const isAscendingActive = orderItem && orderItem.order === ASCENDING;
  const isDescendingActive = orderItem && orderItem.order === DESCENDING;

  const ascendingCallback = useCallback(
    () => onOrder(columnKey, ASCENDING),
    [onOrder, columnKey]
  );

  const descendingCallback = useCallback(
    () => onOrder(columnKey, DESCENDING),
    [onOrder, columnKey]
  );

  if (isMobile)
    return (
      <MobileOrderButtons
        isAscendingActive={!!isAscendingActive}
        isDescendingActive={!!isDescendingActive}
        ascendingCallback={ascendingCallback}
        descendingCallback={descendingCallback}
      />
    );

  return (
    <DesktopOrderButtons
      isAscendingActive={!!isAscendingActive}
      isDescendingActive={!!isDescendingActive}
      ascendingCallback={ascendingCallback}
      descendingCallback={descendingCallback}
    />
  );
};

export default OrderButtons;
